import React from "react";
import { useLocation } from "react-router-dom";

/** ScrollToTop — scrolls to the top of the page on every route change. */
export function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
